<script lang="ts">
    import { Route, Router } from 'yrv'
    import Ztab from '../_common/z/ztab.svelte'
    import TagsManager from './tags-manager.svelte'
    import TagsEntries from './tags-entries.svelte'

    let tabs = [
        {
            title: 'Etiquetas',
            url: '/tags/entries',
        },

        {
            title: 'Configurações',
            url: '/tags/config',
        },
    ]
</script>

<div class="">
    <Ztab class="h-space" {tabs} />
    <Router>
        <Route path="/entries">
            <TagsEntries></TagsEntries>
        </Route>
        <Route path="/config">
            <TagsManager></TagsManager>
        </Route>
    </Router>
    <div class="m-bottom-sm" />
</div>
